import React, { useContext, useEffect, useState } from "react";
import BarChart from "./BarChart";
import AuthContext from "../../../contexts/auth-context";
import useAxios from "../../../hooks/useAxios";
import { urls } from "../../config/variables";
import { validateExpensiveDrugPrescribingProviders } from "../../../Utils/validateHttpResponse";
import Toastify from "../../ui/Toastify";
import { toastify_status } from "../../config/variables";
import AppContext from "../../../contexts/app-context";

const ExpensiveDrugPrescribingProviders = () => {
  const [data, setData] = useState([]);
  const { operation } = useAxios();
  const authCtx = useContext(AuthContext);
  const token = authCtx.token;
  const { globalFilterQuery } = useContext(AppContext);

  const fetchData = () => {
    operation(
      {
        method: "GET",
        url: urls.EXPENSIVE_DRUG_PRESCRIBING_PROVIDERS + globalFilterQuery,
        headers: { Authorization: `token ${token}` },
        data: {},
      },
      handleSetData,
      handleSetDataError
    );
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const handleSetData = (response) => {
    if (validateExpensiveDrugPrescribingProviders(response)) {
      setData(response);
    } else {
      Toastify({
        message: "Invalid expensive drug prescribing providers response data",
        state: toastify_status.ERROR,
      });
    }
  };

  const handleSetDataError = (error) => {
    console.log(error);
  };

  const xAxisData = data.map((item) => item.name);
  const drugNames = Array.from(new Set(data.flatMap((item) => item.drugs.map((d) => d.drug_name))));

  const series = drugNames.map((drug, index) => ({
    name: drug,
    type: "bar",
    stack: "total",
    emphasis: { focus: "series" },
    data: data.map((provider) => {
      const found = provider.drugs.find((d) => d.drug_name === drug);
      return found ? parseFloat(found.cost) : 0;
    }),
    label: {
      show: true,
      position: "top",
      formatter: function (params) {
        if (index === drugNames.length - 1) {
          const doctor = data[params.dataIndex];
          return `$${parseFloat(doctor.total_cost)}`;
        }
        return "";
      },
    },
  }));

  const option = {
    title: {
      text: "High-Cost Drug Prescribers",
      subtext: 'Providers prescribing the most expensive drugs (top 1% by cost)',
      left: "center",
      top: 10,
      textStyle: { fontSize: 16, fontWeight: "bold" },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: function (params) {
        let tooltipText = `<strong>${params[0].axisValue}</strong><br/>`;
        params.forEach((p) => {
          if (p.data > 0) tooltipText += `${p.seriesName}: $${p.data}<br/>`;
        });
        return tooltipText;
      },
    },
    // legend: { data: drugNames, type: "scroll" }, ---> show drug legends
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLabel: {
        interval: 0,
        overflow: "break",
        formatter: function (value) {
          const maxLength = 25;
          if (value.length > maxLength) {
            return value.match(new RegExp('.{1,' + maxLength + '}', 'g')).join('\n');
          }
          return value;
        },
      },
    },
    yAxis: {
      type: "value",
      axisLabel: { formatter: (val) => `$${val}` },
    },
    grid: { top: 80, bottom: 80, left: 60, right: 30 },
    series,
  };

  return <BarChart name="Expensive Drug Prescribing Providers" option={option} dataLength={data.length} />;
};

export default ExpensiveDrugPrescribingProviders;
